<template>
  <section class="service-section text-center bg-black" id="service">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 mx-auto">
          <h2 class="text-white mb-4">{{ t('service.heading') }}</h2>
          <p class="text-white-50 text-center" v-html="t('service.body')"></p>
        </div>
      </div>
      <img class="img-fluid" src="../assets/img/ipad.webp" :alt="t('service.imgAlt')" />
    </div>
  </section>
</template>

<script setup>
  import { useI18n } from 'vue-i18n'
  const { t } = useI18n()
</script>